// @ts-nocheck
import React, { useEffect, useState, useContext } from 'react';
import { createContext } from 'react';
import { ActaAuthContext } from 'pa_kit/auth.js';
import ApiService from 'services/api';
import { ApplicantUser } from 'apps/applicants/models/applicant';
import { CompanyUser } from 'apps/companies/models/company';

const SubscriberAuthContext = createContext();

export default function SubscriberAuthProvider({ children }) {

    const auth = useContext(ActaAuthContext);    

    const [ applicant, setApplicant ] = useState();
    const [ company, setCompany ] = useState();
    const [ isLoading, setIsLoading ] = useState(true);
    const [ isApplicant, setIsApplicant ] = useState(false);
    const [ isCompany, setIsCompany ] = useState(false);

    const [ skipRegistration, setSkipRegistration ] = useState(() => {
        return localStorage.getItem("skipRegistration") === "true";
    });

    const user = auth.user;

    useEffect(() => {           
        const checkSub = async () => {
            if (auth.user) {                
                try {
                    /* Check if logged user is an applicant */
                    const data = await ApiService.checkApplicant(user.attributes.tax_code);
                    setApplicant(new ApplicantUser(user, data));  
                    setIsApplicant(true);
                    setIsLoading(false);
                } catch {
                    try {
                        /* Check if logged user is a company */
                        const data = await ApiService.checkCompany(user.attributes.tax_code);
                        setCompany(new CompanyUser(user, data));  
                        setIsCompany(true);
                        setIsLoading(false);
                    } catch {
                        setIsLoading(false);
                    }                        
                }  
            } else {
                setIsLoading(false);                
            }
        };

        if (auth && !auth.isLoading) {
            checkSub();
        }
    }, [auth.isLoading]);
    

    const subscriberAuth = {
        applicant,
        company,
        isApplicant,
        isCompany,
        isLoading,
        skipRegistration
    };    

    return (
        <SubscriberAuthContext.Provider value={subscriberAuth}>            
            {children}            
        </SubscriberAuthContext.Provider>
    );
}

export { SubscriberAuthContext }